"use client";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { FaLocationArrow } from "react-icons/fa";
import type { PlaceSearchContextType } from "../contexts";
import { type RscRouterParameters } from "../hooks/rsc-router-params";
import { useCurrentLocationButton } from "../hooks/use-current-location-button";
import { SearchOptionWrapper, WrapperProps } from "./wrapper";

export interface PlaceResultProps extends WrapperProps {
  label: string;
}

export const CurrentLocationSearchOption = (
  props: PlaceResultProps &
    RscRouterParameters & { modal: PlaceSearchContextType["modal"] },
) => {
  const { label, router, rsc, modal, ...rest } = props;
  //gets the same modal from PlaceSearch and pass into current location hook
  const { disabled, onClick, isClicked } = useCurrentLocationButton(modal, {
    router,
    rsc,
  });

  return (
    <SearchOptionWrapper
      color="gray.500"
      _hover={{
        bg: "blue.500",
        color: "white",
      }}
      cursor="pointer"
      role="option"
      aria-disabled={disabled}
      _loading={{
        cursor: "progress",
      }}
      _disabled={{
        color: "gray.200",
      }}
      onClick={onClick}
      {...rest}
    >
      <Flex ml="2" alignItems="center">
        {isClicked ? (
          <Spinner h="6" mr="3" />
        ) : (
          <Box as={FaLocationArrow} h="6" mr="3" />
        )}
        <Box fontWeight="semibold">{label}</Box>
      </Flex>
    </SearchOptionWrapper>
  );
};

export default CurrentLocationSearchOption;
